import _ from 'underscore';
import { http, odata as odataInternal } from '@bingads-webui/http-util';

// const browserUrl = window.location.href;

export function wrapOptions(options = {}, config, paramData) {
  const host = config.has(options.host) ? config.get(options.host) : options.host;
  const path = config.has(options.path) ? config.get(options.path) : options.path;

  return _.defaults({
    error(xhr, textStatus, errorThrown) {
      if (options.error) {
        options.error(xhr, textStatus, errorThrown);
      }
    },
    host: host || config.get('odata.url'),
    path: path || config.get('odata.path'),
    params: _.extend({}, paramData, options.params),
    authorization: options.authorization ? `CCMTSmallToken ${config.get('odata.token')}` : null,
  }, options);
}

function buildHeaders(originalHeaders, config) {
  const oDataToken = config.get('odata.token');

  const headers = _.defaults({
    Authorization: `CCMTSmallToken ${oDataToken}`,
  }, originalHeaders);

  const loginType = config.get('odata.loginType');

  if (loginType) {
    headers['x-ms-logintype'] = loginType;
  }

  const sessionId = _.result(config.get('Omniture'), 'SessionId');

  if (!_.isUndefined(sessionId)) {
    headers['x-ms-sessionid'] = sessionId;
  }

  const lcid = config.get('CultureLcid');

  headers['x-ms-lcid'] = lcid;
  headers.lcid = lcid;

  return headers;
}

function wrapOptionsOfODataMethods(options = {}, config, paramData) {
  return _.defaults({
    headers: buildHeaders(options.headers, config),
    multipartPath: config.get('odata.multipart_path'),
  }, wrapOptions(options, config, paramData));
}

function addOptionsToODataMethod(method, config, paramData) {
  // eslint-disable-next-line func-names
  return function (...args) {
    const [url, options, cb] = http.signature(args);

    return method(url, wrapOptionsOfODataMethods(options, config, paramData), cb);
  };
}


export const odata = (config, paramData) => {
  function defaults(options) {
    const originalDefaults = odata.defaults(options);
    return addOptionsToODataMethod(originalDefaults, config, paramData);
  }

  return {
    get: addOptionsToODataMethod(odataInternal.get, config, paramData),
    post: addOptionsToODataMethod(odataInternal.post, config, paramData),
    put: addOptionsToODataMethod(odataInternal.put, config, paramData),
    patch: addOptionsToODataMethod(odataInternal.patch, config, paramData),
    delete: addOptionsToODataMethod(odataInternal.delete, config, paramData),
    upload: addOptionsToODataMethod(odataInternal.upload, config, paramData),
    ajax: addOptionsToODataMethod(odataInternal.ajax, config, paramData),
    defaults,
  };
};

export const getParams = ({ CurrentUser, CurrentCustomer, CurrentAccount }) => {
  if (CurrentCustomer && CurrentAccount && CurrentUser) {
    const paramData = {
      account_id: CurrentAccount.Id,
      customer_id: CurrentCustomer.Id,
      advertisercustomer_id: CurrentAccount.AdvertiserCustomerID,
      user_id: CurrentUser.Id,
    };
    return paramData;
  }
  return null;
};
